interface Category {
  id: string;
  locales?: string[];
}

interface Calcualator {
  category: string;
  id: string;
  slug: string;
  locales?: string[];
  excludedLocales?: string[];
}

export const categories: Category[] = [
  {
    id: "dates",
  },
  {
    id: "numbers",
  },
  {
    id: "length",
  },
  {
    id: "temperature",
  },
  {
    id: "taxes",
    locales: ["ru"]
  },
  {
    id: "tools",
  }
];

export const calculators: Calcualator[] = [
  {
    category: "dates",
    id: "count",
    slug: "dates/count"
  },
  {
    category: "dates",
    id: "age",
    slug: "dates/age",
  },
  {
    category: "dates",
    id: "time_since",
    slug: "dates/time-since",
  },
  // {
  //   category: "dates",
  //   id: "dog-age-in-human-years",
  //   slug: "dates/dog-age-in-human-years",
  // },
  {
    category: "dates",
    id: "korean_age",
    slug: "dates/korean-age",
  },
  {
    category: "dates",
    id: "animal_of_the_year",
    slug: "dates/animal-of-the-year",
  },
  {
    category: "dates",
    id: "today",
    slug: "dates/today",
  },
  {
    category: "dates",
    id: "days_till.spring",
    slug: "how-many-days-till/spring",
  },
  {
    category: "dates",
    id: "days_till.summer",
    slug: "how-many-days-till/summer",
  },
  {
    category: "dates",
    id: "days_till.autumn",
    slug: "how-many-days-till/autumn",
  },
  {
    category: "dates",
    id: "days_till.winter",
    slug: "how-many-days-till/winter",
  },

  {
    category: "numbers",
    id: "number_to_roman",
    slug: "numbers/number-to-roman"
  },
  {
    category: "numbers",
    id: "number_to_binary",
    slug: "numbers/number-to-binary"
  },
  {
    category: "numbers",
    id: "binary_to_decimal",
    slug: "numbers/binary-to-decimal"
  },


  {
    category: "temperature",
    id: "fahrenheit_to_celsius",
    slug: "temperature/fahrenheit-to-celsius"
  },
  {
    category: "temperature",
    id: "celsius_to_fahrenheit",
    slug: "temperature/celsius-to-fahrenheit"
  },
  {
    category: "temperature",
    id: "kelvin_to_celsius",
    slug: "temperature/kelvin-to-celsius"
  },
  {
    category: "temperature",
    id: "celsius_to_kelvin",
    slug: "temperature/celsius-to-kelvin"
  },
  {
    category: "temperature",
    id: "kelvin_to_fahrenheit",
    slug: "temperature/kelvin-to-fahrenheit"
  },
  {
    category: "temperature",
    id: "fahrenheit_to_kelvin",
    slug: "temperature/fahrenheit-to-kelvin"
  },


  {
    category: "length",
    id: "inches_to_mm",
    slug: "length/inches-to-mm"
  },
  {
    category: "length",
    id: "inches_to_cm",
    slug: "length/inches-to-cm"
  },
  {
    category: "length",
    id: "inches_to_meters",
    slug: "length/inches-to-meters"
  },
  {
    category: "length",
    id: "inches_to_feet",
    slug: "length/inches-to-feet"
  },
  {
    category: "length",
    id: "feet_to_inches",
    slug: "length/feet-to-inches"
  },
  {
    category: "length",
    id: "feet_to_meters",
    slug: "length/feet-to-meters"
  },
  {
    category: "length",
    id: "feet_to_cm",
    slug: "length/feet-to-cm"
  },
  {
    category: "length",
    id: "feet_to_mm",
    slug: "length/feet-to-mm"
  },

  {
    category: "taxes",
    id: "residency",
    slug: "taxes/residency",
    locales: ["ru"]
  },

  {
    category: "tools",
    id: "qr_generator",
    slug: "qr-code-generator",
  },
  {
    category: "tools",
    id: "myip",
    slug: "tools/myip",
  }
];